import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const UnlockedNewIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2C11.933 2 13.5 3.567 13.5 5.5V8.5H15L15.1025 8.50488C15.6067 8.55621 16 8.98232 16 9.5V17.5L15.9951 17.6025C15.9472 18.073 15.573 18.4472 15.1025 18.4951L15 18.5H5L4.89746 18.4951C4.42703 18.4472 4.05278 18.073 4.00488 17.6025L4 17.5V9.5C4 8.98232 4.39333 8.55621 4.89746 8.50488L5 8.5H12.5V5.5C12.5 4.11929 11.3807 3 10 3C8.61929 3 7.5 4.11929 7.5 5.5C7.5 5.77614 7.27614 6 7 6C6.72386 6 6.5 5.77614 6.5 5.5C6.5 3.567 8.067 2 10 2ZM5 17.5H15V9.5H5V17.5ZM10 11.5C10.5523 11.5 11 11.9477 11 12.5C11 12.8698 10.7984 13.1912 10.5 13.3643V15C10.5 15.2761 10.2761 15.5 10 15.5C9.72386 15.5 9.5 15.2761 9.5 15V13.3643C9.20157 13.1912 9 12.8698 9 12.5C9 11.9477 9.44772 11.5 10 11.5Z"
        fill="inherit"
      />
    </SvgWrapper>
  );
};
